
export const _a0z = { // 処理情報

  _a0r: { // 処理情報 履歴対象外、削除あり
    v0: {
      itlz: {
        _a0rd1110s: '',
        _a0rt1110i: -1,
        _a0rs1110i: -1,
        _a0ra1110s: '',
      },
      fldz: {
        _a0rd1110s: {
          // 処理登録日時
        },
        _a0rd2110s: {
          // 処理完了日時
        },
        // 指定時刻送信 1/4 _hd_a0, _smMLZ, _smCWK
        _a0rd2210s: {
          // 処理継続確認日時
        },
        _a0rd2310s: {
          // 処理開始日時
        },
        _a0rd3110s: {
          // 処理開始予定日時
        },
        _a0rt1110i: {
         // 処理種別
         // 10:メール 
         // 20:クエリ 
         // 30:外部連携
         // 40:オフライン抽選
        },
        _a0rs1110i: {
         // 処理状況
         // 10: 未処理
         // 20: 処理中
         // 30: 処理済
        },
        _a0ra1110t: { // 将来的に _a0ra1110j へ変更予定
         // 処理内容(json)
        },
        _a0ra2110t: {
         // 処理結果
        },
        _a0ra3110s: {
         // 処理群ID
        },
        _a0ra4110t: { // 将来的に _a0ra4110j へ変更予定
         // 開始通知メール内容、本メール内容が設定されており同一の処理群IDで全て未処理の場合のみメール送信
        },
        _a0ra4210t: { // 将来的に _a0ra4210j へ変更予定
         // 終了通知メール内容、本メール内容が設定されており同一の処理群IDで全て処理済の場合のみメール送信
        },
      },
    },
  },

};
